import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeBlueprintLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 144,
	height: 144,
	viewBox: "0 0 144 144",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17410_117063)",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				x: 10.5,
				y: 35.4648,
				width: 114.329,
				height: 91.3444,
				rx: 3,
				transform: "rotate(-5 10.5 35.4648)",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M115.5 60.75C114.3 60.75 93.5 62.25 83.25 63",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.47 28.3325C125.44 27.9901 126.457 28.7099 126.457 29.7388V116.908C123.257 118.107 121.606 118.722 119.934 119.233C115.498 120.589 110.919 121.419 106.29 121.707C104.459 121.82 102.608 121.821 98.8457 121.821H20.0645C18.6293 121.821 17.6283 121.819 16.873 121.717C16.1393 121.619 15.7504 121.438 15.4736 121.162C15.1969 120.885 15.0166 120.496 14.918 119.762C14.8165 119.007 14.8145 118.006 14.8145 116.571V37.7134C14.8145 36.2782 14.8164 35.2773 14.918 34.522C15.0166 33.7882 15.1969 33.3993 15.4736 33.1226C15.7504 32.8459 16.1394 32.6655 16.873 32.5669C17.6283 32.4654 18.6293 32.4634 20.0645 32.4634H100.352C108.567 32.4633 116.723 31.0668 124.47 28.3325Z",
				fill: "white",
				stroke: "#4F49BA",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45 39L46.5 114.75",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M60.75 39L63 114.75",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78.75 39L82.5 115.5",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96.75 40.5L100.5 114",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39 91.5V80.25L57 66.75L69.75 57L104.25 69L105 75H109.5V91.5H39Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 72,
				y: 74.25,
				width: 36.75,
				height: 16.5,
				stroke: "#A8AAE3",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 77.1562L43.125 76.3125V90.375H42V77.1562Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47.625 72.9375L48.75 72.0938V90.375H47.625V72.9375Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 70.5,
				y: 81,
				width: 7.5,
				height: 1.5,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 54.375,
				y: 58.875,
				width: 4.5,
				height: 31.5,
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 53.8125,
				y: 57.75,
				width: 5.625,
				height: 1.125,
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.75 57.1875L69 55.5L71.25 56.2475V91.5H66.75V57.1875Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98.25 66.3003L103.875 68.1003V72.3753L98.25 72.3753V66.3003Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.375 68.3438L39 79.875V90H54.375V90.375H58.875V90H66.75V91.5H37.5V79.125L54.375 66.4688V68.3438ZM66.75 59.0625L58.875 64.9688V63.0938L66.75 57.1875V59.0625Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M105 67.3125V73.5H71.25V72H103.5V68.3984L71.25 57.8164V56.2383L105 67.3125Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 74.625,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 76.875,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 79.125,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 81.375,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 83.625,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 98.25,
				y: 85.875,
				width: 6.75,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 78,
				y: 72,
				width: 1.5,
				height: 19.5,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 78,
				y: 60,
				width: 1.5,
				height: 12,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 79.5,
				y: 81,
				width: 7.5,
				height: 1.5,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78 67.5H99V69H78V67.5Z",
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 38.625,
				y: 83.625,
				width: 3.375,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 43.125,
				y: 83.625,
				width: 4.5,
				height: 1.125,
				fill: "#A8AAE3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.75 54L104.25 51.75",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.25 106.5L87.75 105",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.25 97.5L107.25 93.75",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.5 38.25L30 115.5",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M110.25 40.5L115.5 112.5",
				stroke: "#EAEBF8",
				strokeWidth: 1.05,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.9668 7.4427L86.1667 1.5L101.167 6.75L95.9167 17.25L95.5478 17.8954C93.8094 20.9377 92.6622 24.2813 92.1667 27.75C91.6894 31.0906 89.8118 34.0699 87.004 35.9418L86.9167 36C85.1167 37.2 84.4314 36.5 84.3137 36L82.7452 39.8094C81.5323 42.7548 79.9065 45.5127 77.9167 48C77.2565 48.6601 76.1824 48.3334 76.1185 47.402C76.0432 46.3059 76.0659 44.9029 76.4167 43.5L76.4171 43.4984C77.1674 40.4968 79.4166 31.5001 78.6667 32.25C77.5603 33.3563 75.8948 31.9523 75.9748 30.3898C76.0372 29.1717 76.0008 28.1658 75.6667 28.5C74.9167 29.25 75.954 30.75 73.5 30C72.2218 29.6094 72.2751 28.4049 72.6197 27.4463C72.2457 27.6334 71.758 27.75 71.1667 27.75C69.6667 27.75 71.1667 23.25 71.1667 23.25L72.0616 21.4601C73.4522 18.6789 75.3607 16.1886 77.6847 14.1228C79.8228 12.2224 81.6106 9.96134 82.9668 7.4427Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M96 15.75L83.25 8.25L96 17.25",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.25 93L-11.471 94.2862C-16.8392 94.6992 -19.5907 100.919 -16.2852 105.169C-14.6007 107.335 -11.7736 108.267 -9.13142 107.527L5.25 103.5L13.7767 102.079C14.0918 102.026 14.4022 101.949 14.7052 101.848C15.8744 101.459 17.1341 101.431 18.3191 101.77L21.75 102.75L23.4067 103.164C24.2989 103.387 25.215 103.5 26.1346 103.5H27.1181C28.5131 103.5 29.8819 103.121 31.0781 102.403L31.4116 102.203C32.449 101.581 33.2874 100.675 33.8284 99.5932L34.1157 99.0187C34.3684 98.5132 34.5 97.9558 34.5 97.3906V95.2156C34.5 94.4062 33.8438 93.75 33.0344 93.75C32.5443 93.75 32.0867 93.9949 31.8149 94.4026L30.962 95.6819C30.821 95.8935 30.6595 96.0905 30.4797 96.2703L30.2391 96.5109C28.8644 97.8856 26.6356 97.8856 25.2609 96.5109C24.9238 96.1738 24.6587 95.7718 24.4817 95.3291L23.9741 94.0603C23.5093 92.8982 23.5093 91.6018 23.9741 90.4397L24.2734 89.6916C24.5777 88.9307 25.1807 88.3277 25.9416 88.0234C27.3877 87.4449 29.0515 88.0783 30.0655 89.2605C30.2731 89.5024 30.5012 89.7512 30.75 90C31.5076 90.7576 32.4566 91.3239 33.2103 91.6989C33.9524 92.068 34.8189 91.7716 35.2787 91.082C35.7109 90.4336 35.6871 89.5831 35.2517 88.9368C34.5265 87.8604 33.4694 86.1583 33 84.75C32.25 82.5 29.25 81 27.75 81C25.4568 81 23.013 79.83 23.3532 77.5621L24.6425 68.9667C24.7128 68.4982 24.6511 68.0193 24.4645 67.5839L24.1057 66.7466C23.4359 65.1839 21.2776 65.0374 20.4028 66.4953C20.3014 66.6643 20.2246 66.8467 20.1744 67.0372L17.2785 78.0418C17.1801 78.4156 16.6271 78.3306 16.6455 77.9446L17.1983 66.3359C17.2316 65.6361 17.0085 64.9482 16.5709 64.4011L16.1118 63.8273C15.169 62.6487 13.3674 62.6768 12.4618 63.8843C12.162 64.284 12 64.7701 12 65.2696V81.4686C12 81.5314 11.9139 81.5491 11.8892 81.4914L8.35348 73.2415C7.98633 72.3848 6.81517 72.2773 6.29816 73.0528C6.10884 73.3367 6.05229 73.6871 6.14211 74.0163C7.41879 78.6961 9.57794 87.6882 9 90C8.4 92.4 6.25 93 5.25 93Z",
				fill: "white",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M134.539 128.889L148.5 130.5L146.25 110.25H135.505C132.783 110.25 131.421 110.25 130.551 111.085C129.68 111.92 129.624 113.28 129.51 116L129.232 122.679C129.122 125.321 129.067 126.642 129.833 127.538C130.599 128.434 131.912 128.586 134.539 128.889Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M118.5 99.75C123.226 102.113 126.711 105.872 128.589 108.461C129.408 109.591 129.715 110.989 129.648 112.383L129 126L121.5 123C120.25 122.5 117.15 121.5 114.75 121.5H112.325C109.994 121.5 107.715 120.81 105.775 119.517C104.765 118.843 103.864 118.017 103.105 117.068L101.25 114.75L97.8305 110.191C97.2989 109.482 97.6179 108.461 98.4583 108.181C98.8035 108.066 99.181 108.098 99.492 108.287C100.546 108.927 101.996 109.94 103.304 110.884C105.396 112.394 108.066 113.614 110.363 112.439C111.005 112.111 111.534 111.649 111.75 111C112.184 109.697 109.239 107.268 106.442 105.362C104.626 104.124 102.307 103.977 100.266 104.793L91.8621 108.155C90.387 108.745 88.8341 107.495 89.0953 105.928C89.1935 105.339 89.5449 104.823 90.0569 104.516L98.6261 99.3743C102.306 97.1663 106.558 95.9111 110.728 96.9268C113.09 97.5022 115.795 98.3974 118.5 99.75Z",
				fill: "white",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M102.941 131.198C102.88 129.156 101.174 127.55 99.1317 127.611L95.4334 127.722L95.6555 135.119L93.4125 135.186L93.1905 127.789L61.3175 128.746C56.1685 128.901 51.0334 130.094 46.3324 132.2C45.8707 132.407 45.8672 133.07 46.3335 133.266C51.215 135.316 56.4795 136.295 61.7715 136.136L99.3538 135.008C101.396 134.946 103.002 133.241 102.941 131.198Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M87.0795 1.02543L85.8098 0.581055L82.3063 7.08764C80.9917 9.529 79.2588 11.7206 77.1864 13.5628C74.791 15.692 72.824 18.2587 71.3907 21.1252L70.4719 22.9628L70.4551 23.0133L71.1666 23.2505C70.4551 23.0133 70.4545 23.0149 70.4545 23.015L70.4534 23.0183L70.4497 23.0297L70.4362 23.071C70.4248 23.1065 70.4085 23.1576 70.3886 23.2221C70.3487 23.351 70.2938 23.5338 70.233 23.7529C70.112 24.1883 69.964 24.7787 69.8643 25.3772C69.7677 25.9566 69.7023 26.6209 69.794 27.1707C69.8399 27.4461 69.9371 27.7701 70.1597 28.0373C70.4087 28.3361 70.7627 28.5005 71.1666 28.5005C71.336 28.5005 71.5006 28.4923 71.6597 28.4762C71.6561 28.6826 71.6734 28.8916 71.7187 29.0978C71.8807 29.834 72.3847 30.4439 73.2807 30.7178C73.9154 30.9118 74.4563 31.0065 74.9016 30.9261C75.0185 30.905 75.1321 30.8713 75.2399 30.823C75.3357 31.6846 75.8054 32.4565 76.4261 32.9215C76.7987 33.2006 77.2616 33.3956 77.7669 33.3963C77.8314 33.3964 77.8957 33.3933 77.9594 33.3871C77.8377 34.1332 77.6261 35.1629 77.3722 36.3052C76.8124 38.8246 76.0649 41.8147 75.6894 43.317L75.689 43.3186C75.313 44.8227 75.2916 46.3099 75.3701 47.4539C75.4237 48.2336 75.9206 48.8051 76.564 49.0123C77.1945 49.2152 77.9206 49.0571 78.4469 48.5309L78.4763 48.5015L78.5022 48.469C80.5365 45.9261 82.1986 43.1067 83.4386 40.0955L84.5885 37.3029C84.6638 37.3305 84.7436 37.3536 84.8281 37.3716C85.531 37.5212 86.3664 37.2687 87.3326 36.6246L87.4199 36.5664C90.4052 34.5761 92.4016 31.4085 92.909 27.8566C93.3912 24.4815 94.5074 21.2282 96.1989 18.2681L96.5781 17.6045L102.218 6.32403L100.854 5.84646L99.427 8.55249L95.255 16.8965L94.8966 17.5239C93.1112 20.6482 91.933 24.0821 91.4241 27.6445C90.977 30.7739 89.2181 33.5648 86.5878 35.3183L86.5005 35.3765C85.7126 35.9018 85.3056 35.9284 85.1627 35.9083L86.8601 31.7861C87.0178 31.4031 86.8351 30.9647 86.4521 30.807C86.0691 30.6493 85.6308 30.8319 85.4731 31.215L82.0515 39.5243C80.8722 42.3885 79.2934 45.0713 77.3622 47.4929C77.2357 47.6049 77.1062 47.611 77.0237 47.5844C76.9785 47.5699 76.9446 47.5452 76.9211 47.5156C76.8994 47.4884 76.8727 47.4395 76.8666 47.3512C76.7947 46.3028 76.8188 44.9841 77.1442 43.6823L77.1452 43.6781C77.5203 42.178 78.272 39.1709 78.8365 36.6306C79.118 35.3637 79.3574 34.1934 79.4787 33.3803C79.537 32.99 79.5779 32.6215 79.5651 32.3588C79.5617 32.2889 79.5535 32.2 79.5311 32.1074C79.5133 32.0336 79.4639 31.8561 79.3129 31.6996C79.2275 31.6111 79.1061 31.5263 78.9483 31.4836C78.791 31.4412 78.6449 31.4533 78.5291 31.4852C78.3239 31.5417 78.1914 31.6651 78.1362 31.7202C77.9922 31.8642 77.8688 31.8965 77.7691 31.8963C77.6534 31.8962 77.4975 31.8499 77.3254 31.721C76.9682 31.4534 76.6973 30.9453 76.7238 30.4287C76.755 29.8184 76.7654 29.206 76.7141 28.7747C76.7008 28.6631 76.6815 28.5458 76.6513 28.4343C76.6243 28.3346 76.5732 28.1795 76.4659 28.0354C76.3461 27.8747 76.0985 27.6638 75.7305 27.6873C75.4257 27.7068 75.2244 27.882 75.1362 27.9702C74.7914 28.315 74.6776 28.7262 74.6211 29.0106C74.6033 29.1005 74.5861 29.2087 74.573 29.2909L74.573 29.2909C74.5676 29.3249 74.5629 29.3545 74.5592 29.3765C74.5539 29.4074 74.549 29.4333 74.5446 29.455C74.4156 29.4525 74.164 29.4192 73.7191 29.2833C73.337 29.1665 73.2284 28.9788 73.1837 28.7754C73.136 28.5587 73.1586 28.2705 73.2463 27.9499C73.8427 27.5573 74.2499 26.9564 74.2499 26.2505C74.2499 26.1704 74.2468 25.8451 73.9734 25.6021C73.6215 25.2892 73.2215 25.4219 73.0951 25.4797C72.9514 25.5454 72.8444 25.6404 72.7827 25.7003C72.7113 25.7696 72.6448 25.8473 72.5849 25.9249C72.4013 26.1627 72.2041 26.4975 72.0398 26.8755C71.8377 26.9416 71.5881 26.9884 71.2887 26.9985C71.2836 26.9781 71.2784 26.9535 71.2735 26.9241C71.2245 26.6301 71.2529 26.1694 71.3439 25.6238C71.4316 25.0973 71.5648 24.5627 71.6783 24.1544C71.7346 23.9516 71.7852 23.7829 71.8215 23.6656C71.8387 23.6101 71.8526 23.5663 71.8624 23.536L72.7323 21.796C74.0803 19.1002 75.9302 16.6863 78.1829 14.6839C80.3865 12.7251 82.2292 10.3947 83.627 7.79879L86.0249 3.34564L87.0795 1.02543ZM73.8272 26.7769C73.832 26.7722 73.8316 26.7732 73.826 26.778L73.8272 26.7769Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 108.73L3.88923 108.19C4.65179 108.084 5.19768 107.399 5.13098 106.632L3.93226 92.8464C3.83751 91.7568 2.77672 91.0209 1.72291 91.3136L0 91.7922V108.73Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17410_117063",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 144,
			height: 144,
			fill: "white"
		})
	}) })]
});
export default SvgHomeBlueprintLight;
